module.exports = __webpack_public_path__ + "static/media/LPDI.f734c539.png";